import React, { useState } from 'react';
import { Review } from '../../../typings/reviews';
import { getRatingPercent } from '../../../utils/general';
import FiveStars from '../../../components/five-stars';
import { AppConstants } from '../../../utils/app-constants';
import {
  ReviewDataWrapper,
  ReviewCommentWrapper,
  ReviewerNameWrapper,
  ReplyCommentWrapper,
  ReviewerApplyNameWrapper,
  StyledOpacityWrapper,
  ReviewCardContainer,
  ReviewerContainerWrapper,
  ReviewReplyCommentWrapper,
} from './styled';
import CollapseText from '../../../components/collapse-text';
import { CommentWriter } from '../../../components/comment-writer';
import { FormattedDate } from '../../../components/formated-date';

interface ReviewCardProps {
  review: Review;
  opacity?: boolean;
  onHandleCollapseTextAction: (state: boolean) => void;
}
const ReviewCard: React.FC<ReviewCardProps> = (props): JSX.Element => {
  const { review, opacity, onHandleCollapseTextAction } = props;
  const [expandContainer, setExpandContainer] = useState<{
    state: boolean;
    editBy: 'reviewer' | 'reply' | undefined;
    reviewerState?: boolean;
    replyState?: boolean;
  }>({ state: false, editBy: undefined });

  // Component Constants
  const replyLabel = 'Volkswagen response';
  const starSize = '18px';
  const twoCommentsLines = 4;
  const oneCommentLines = 12;
  const textLineHeight = 1.5; // 24px to em base on 16px

  const hasDealerReply = review.reply && review.reply.dealer_response_text;
  /**
   * Handle collapseEvent when the comment or reviewer
   * or reply change container height for display more text
   * @param state
   * @param collapseEditor
   */
  const handleCollapseEvent = (
    state: boolean,
    collapseEditor: 'reviewer' | 'reply',
  ) => {
    let newExpandData: any = { state: true, editBy: collapseEditor };
    if (collapseEditor === 'reviewer') {
      newExpandData.reviewerState = state;
    } else if (collapseEditor === 'reply') {
      newExpandData.replyState = state;
    }
    let mergedData = { ...expandContainer, ...newExpandData };
    if (!mergedData.reviewerState && !mergedData.replyState) {
      mergedData.state = state;
    }
    setExpandContainer(mergedData);

    onHandleCollapseTextAction(state);
  };

  return (
    <ReviewCardContainer
      containerHeight={!expandContainer.state}
      className="Review-container"
    >
      <StyledOpacityWrapper isOpacity={opacity} />
      <ReviewerContainerWrapper>
        <ReviewerNameWrapper>
          <CommentWriter writer={review.reviewer.displayName} />
        </ReviewerNameWrapper>
        <ReviewDataWrapper>
          <FiveStars
            percent={getRatingPercent(review.rating)}
            starColor={AppConstants.StarColor}
            background={AppConstants.StarBackground}
            starSize={starSize}
          />
          <FormattedDate date={review.created} />
        </ReviewDataWrapper>
        <ReviewCommentWrapper>
          <CollapseText
            text={review.content}
            lines={hasDealerReply ? twoCommentsLines : oneCommentLines}
            lineHeight={textLineHeight}
            setStateContainer={(state: boolean) =>
              handleCollapseEvent(state, 'reviewer')
            }
          />
        </ReviewCommentWrapper>
      </ReviewerContainerWrapper>
      {hasDealerReply && (
        <ReplyCommentWrapper>
          <ReviewerApplyNameWrapper>
            <div>
              <CommentWriter writer={replyLabel} />
            </div>
            <FormattedDate date={review.reply.dealer_response_date} />
          </ReviewerApplyNameWrapper>
          <ReviewReplyCommentWrapper>
            <CollapseText
              text={review.reply.dealer_response_text}
              lines={twoCommentsLines}
              lineHeight={textLineHeight}
              dynamicLines
              setStateContainer={(state: boolean) =>
                handleCollapseEvent(state, 'reply')
              }
            />
          </ReviewReplyCommentWrapper>
        </ReplyCommentWrapper>
      )}
    </ReviewCardContainer>
  );
};
export default ReviewCard;
